<template>
  <intro-box>
    <div class="text-content">
      <div v-html="description" />
    </div>
    <div class="introduction-spacer">

    </div>
    <div class="bottom_align">
      <button v-if="show_back_button" type="button" class="button is-secondary is-rounded border" @click="goToLastStep">
        Tillbaka
      </button>
      <button type="button" class="button is-primary is-rounded" v-bind:class="button_classes" @click="goToFirstStep">
        Jag förstår, nu kör vi!
      </button>
    </div>
  </intro-box>
</template>

<script>
import IntroBox from '@/components/elements/IntroBox.vue'

export default {
  computed: {
    task() {
      return this.$store.state.assignment.task
    },
    chapter() {
      return this.$store.state.assignment.chapter
    },
    description() {
      return this.task.description
    },
    show_back_button(){
      if (this.task.scene_number) {
        return true
      } else {
        return false
      }
    },
    button_classes() {
      return {
        'right': this.show_back_button
      }
    }

  },
  components: {
    IntroBox
  },
  methods: {
    goToFirstStep() {
      this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/step/1`})
    },

    goToLastStep() {
      if(this.task.scene_number) {
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}/video`})
      }else{
        this.$router.push({path: `/assignment/${this.$store.state.assignment.slug}`})
      }

    }
  }

}
</script>
<style>
  .text-content {
    display: table-row;
  }
  .introduction-spacer {
    display: table-row;
    height: 2rem;
  }
  .bottom_align{
    display: table-row;
    vertical-align: bottom;
    width: 100%;
    height: 36px;
  }
  .button {
    margin-top: auto;
    bottom: 0;
  }
  .button.right{
    float: right;
  }
</style>
